<script lang="ts">
    import { createEventDispatcher } from 'svelte'
    import GoalboardMembers from '../tools/goalboards/goalboard-members.svelte'
    import Popover from './popover.svelte'
    const dispatch = createEventDispatcher()

    function onClose() {
        dispatch('close')
    }
</script>

<Popover on:close={onClose} height="100px" title="Metas">
    <div class="goalboard-popup">
        <GoalboardMembers allFromLoggedUser={true} form={true}></GoalboardMembers>
    </div>
</Popover>

<style>
    .goalboard-popup {
        padding: 0px 16px 16px 16px;
        display: flex;
        justify-content: center;
    }
</style>
